define('meetings/lib/start-meeting/start-meeting',['require','exports','module','api-access','tagmanager','mixpanel-helper','cookie-handler','bowser','web-urls','meetings/lib/telemetry-client/telemetry-service','../../embedded-launch'],function (require, exports, module) {
    var userApi = require('api-access').user;
    var tagmanager = require('tagmanager');
    var mixpanelHelper = require('mixpanel-helper');
    var cookieHandler = require('cookie-handler');
    var bowser = require('bowser');
    var webUrls = require('web-urls');
    var telemetrySvc = require('meetings/lib/telemetry-client/telemetry-service');
    var embeddedLaunch = require('../../embedded-launch');

    var endpointJoin = function (data, options) {
        var isMobile = options.isMobile;
        var isFreeTier = data.tierName === 'g2mfree';
        var isNativeDisabled = data.nativeEndpointDisabled;
        var unsupportedOS = options.unsupportedOS;

        return isMobile || (!isFreeTier && !isNativeDisabled && !unsupportedOS);
    };

    var webJoin = function (data, options) {
        var isWebViewerAllowed = data.webViewerAllowed;
        var isBrowserCompatible = options.isBrowserHtml5Compatible;

        return isWebViewerAllowed && isBrowserCompatible;
    };

    var startMeeting = function (meeting, options) {
        var baseUrl = webUrls.get('baseUrl');
        var sessionTrackingId = telemetrySvc.getSessionTracking('mfe');

        telemetrySvc.report({
            ev_name: 'joinStart',
            sa_method: baseUrl + '::' + options.saMethod,
            ga_meetingId: meeting.meetingId,
            ga_id_sessiontracking: sessionTrackingId
        });

        tagmanager.gaEvent({
            category: 'My Meetings',
            action: 'Start Meeting',
            label: meeting.isUpcoming ? 'Upcoming Meeting' : 'Past Meeting'
        });

        mixpanelHelper.track('Start a Meeting', {
            ID: meeting.meetingId,
            Type: meeting.type
        });

        return userApi.settings().then(function (data) {
            options.unsupportedOS = cookieHandler.get('unsupportedOS') === 'true';
            if (bowser.name === 'Safari') {
                options.isMobile = window.hasOwnProperty('ontouchstart') && window.ontouchstart !== undefined;
            } else {
                options.isMobile = bowser.mobile;
            }

            if (endpointJoin(data, options)) {
                setTimeout(function () {
                    embeddedLaunch(meeting.meetingId, sessionTrackingId);
                }, 200);
            } else {
                var sessionParam = sessionTrackingId ? '?sessionTrackingId=' + sessionTrackingId : '';
                window.location = '/host/' + meeting.meetingId + sessionParam;
            }
        });
    };
    module.exports = {
        startMeeting: startMeeting,
        endpointJoin: endpointJoin,
        webJoin: webJoin
    };
});

